module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HqWy8z/Images/cover.jpg?1685327251863",
      "alt": "This image is the cover for the book Rising Frenzy, Men of Myth"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rising Frenzy, Men of Myth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Men of Myth: Book Two")])])]), _c('p', [_vm._v("Heartbroken, angry, and hurting, warlock Finn de Morisco feels darkness growing inside, altering every aspect of his life. There are moments when the man he used to be seems to have been devoured completely. Retreating from his family and everything he once held dear, Finn attempts to escape the despair left in the wake of Brett’s rejection—only to find dangers he never knew existed.")]), _vm._v(" "), _c('p', [_vm._v("Still struggling with the decision to leave everything he knew behind, Brett Wright is swept into a maelstrom as he searches for his place within his newly discovered family. Life beneath the surface of the ocean should have been unlike anything he’s ever known, yet prejudice over his demon ancestry and homosexuality follows him. Even the existence he begins to build may not last as those he is learning to love face extinction.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brandon Witt\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0